import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Error from "../../../../../components/utils/portal/error/Error";
import Loading from "../../../../../components/utils/portal/loading/Loading";
import { getDataPage } from "../../../../../app/educationalInstitutions/internationalAcademy/internationalAcademySlice";
import { useTranslation } from "react-i18next";
import MainBanner from "../../../../../components/mainBanner/MainBanner";

function Banner() {
  // fetch data
  const dispatch = useDispatch();
  const { isLoading, dataPage, error } = useSelector((state) => state.internationalAcademy);
  useEffect(() => {
    dispatch(getDataPage());
  }, []);

  // change language handler
  const { i18n, t } = useTranslation();

  // loading
  if (isLoading) {
    return <Loading />;
  }
  // error
  if (error) {
    return <Error error={error.message} />;
  }
  return (
  
    <section className="banner">
      <MainBanner
        background={dataPage?.result?.image}
        title={`${i18n.language === "en" ? dataPage?.result?.titleEn : dataPage?.result?.titleAr }`}
        // subTitle={`${i18n.language === "en" ? dataPage?.result?.descriptionEn : dataPage?.result?.descriptionAr }`}
      />
    </section>
  );
}

export default Banner;
